export const initShippingMethod = {
  id: 'new',
  name: '',
  internal_name: '',
  regions: [],
  carrier: {},
  currency: 'EUR',
  description: '',
  price: '',
  location: {},
  delivery_days_range: {
    lower: '',
    upper: '',
  },
  availability_criterion_ids: [],
  duties_adjustment_rate: 0,
  calculate_handling_fees: false,
}
